module.exports = __webpack_public_path__ + "img/fashion_thumbnail-400x300.8f8470d5.jpg";